const TRP_TYPE = [
  { _id: 1, label: "Consejo Técnico" },
  { _id: 2, label: "Junta Académica" },
];

export { TRP_TYPE };
